export class UserModel {
    UserId: number;
    QueryValue: string;
    UserEmail: string;
    ExtralumEmail: string;
    UserName: string;
    UserLastName: string;
    AdminComment: string;
    HasShoppingCartItems: number;
    RequireReLogin: number;
    FailedLoginAttempts: number;
    CannotLoginUntilDateUtc: Date;
    Active: number;
    Deleted: number;
    IsSystemAccount: number;
    SystemName: string;
    LastIPAddress: string;
    CreatedOnUtc: Date;
    LastLoginDateUtc: Date;
    LastActivityDateUtc: Date;
    UserPassword: string;
    Token: string;
    Action: string;
    Gender: number;
    BirthDate: Date;
    CustAccountList: string;
    ProjectList: string;
    ReqPasswordChange: number;
    ReqBimPasswordChange: number;
    WebCatalogUser: number;
    ECommerce: number;
    AllowConfigAddress: boolean;
    SetUpAddressPreferences: boolean;

    constructor() {
        this.UserId = 0;
        this.QueryValue = '';
        this.UserEmail = '';
        this.ExtralumEmail = '';
        this.UserName = '';
        this.UserLastName = '';
        this.AdminComment = '';
        this.HasShoppingCartItems = 0;
        this.RequireReLogin = 0;
        this.FailedLoginAttempts = 0;
        this.Active = 0;
        this.Deleted = 0;
        this.IsSystemAccount = 0;
        this.SystemName = '';
        this.LastIPAddress = '';
        this.BirthDate = new Date();
        this.Gender = 0;
        // this.LastActivityDateUtc = new Date();
        this.UserPassword = '';
        this.Token = '';
        this.Action = '';
        this.CustAccountList = '';
        this.ProjectList = '';
        this.ReqPasswordChange = 0;
        this.ReqBimPasswordChange = 0;
        this.WebCatalogUser = 0;
        this.ECommerce = 1;
        this.AllowConfigAddress = false;
        this.SetUpAddressPreferences = false;
    }
}
